import './index.css';

export default {
  name: 'Adialog',
  props: {
    id: { type: String, default: () => (`a-dialog-${Math.random().toString().substring(2)}`) },
    full: { type: Boolean, default: () => false },
    wide: { type: Boolean, default: () => false },
    check: { type: Boolean, default: () => false },
    loading: { type: Boolean, default: () => false },
    lockScroll: { type: Boolean, default: () => true },
    destroyOnClose: { type: Boolean, default: () => false },
    closeOnClickModal: { type: Boolean, default: () => false },
    visible: { type: Boolean, default: () => false },
    finishText: { type: String, default: () => '保存' },
    submitText: { type: String, default: () => '确定' },
    rejectText: { type: String, default: () => '驳回' },
    cancelText: { type: String, default: () => '取消' },
  },
  data() {
    return {
      key: `${this.visible}-${Math.random()}`,
    }
  },
  watch: {
    visible(status = false) {
      if (status === true) this.key = `${status}-${Math.random()}`;
    }
  },
  methods: {
    format() {
      if (this.check == false) return true;
      let data = [];
      let pass = true;
      let elements = this.$slots.default;
      (function recursion(node = []) {
        if (node.length > 0) node.forEach(a => {
          if (a && a.componentInstance) {
            let item = a.componentInstance;
            if (item.$children && item.$children.length && item.$children.length > 0) recursion(item.$children);
            if (item.result && item.result()) data.push(item.result());
            if (item.verify && !item.verify()) pass = false;
          } else {
            if ((a.result) && a.result()) data.push(a.result());
            if ((a.verify) && !a.verify()) pass = false;
          }
        });
      })(elements);
      if (pass == false) return false;
      let params = data.length && data.length > 0 ? (data.length && data.length > 1 ? data : data[0]) : null;
      return params;
    },
    finish(e) {
      e.preventDefault();
      if (this.format()) this.$emit('finish', this.format());
    },
    submit(e) {
      e.preventDefault();
      if (this.format()) this.$emit('submit', this.format());
    },
    reject(e) {
      e.preventDefault();
      this.$emit('reject', this.format());
    },
    cancel(e) {
      e.preventDefault();
      this.$emit('cancel', this.format());
    },
  },
  render() {
    const {
      top = '10vh',
      size = 'small',
      title = '编辑',
      width = this.full ? '100%' : (this.wide ? '1200px' : '600px'),
      padding = '16px',
      height = 'auto',
      maxHeight = '68vh',
      styles = {},
      action = [],
      ...attrs
    } = this.$attrs;
    const { close = null, finish = null, submit = null, reject = null, cancel = null } = this.$listeners;
    return (
      <div id={this.id} class="a-dialog">
        <el-dialog
          top={top}
          title={title}
          width={width}
          visible={this.visible}
          lock-scroll={this.lockScroll}
          destroy-on-close={this.destroyOnClose}
          close-on-click-modal={this.closeOnClickModal}
          on-close={close ? () => close() : (cancel ? () => cancel() : (submit ? () => submit() : (() => false)))}
          {...{ attrs }}
        >
          {this.$slots.header}
          <div class="a-dialog-body" key={this.key} v-loading={this.loading} style={{ padding, height, maxHeight, ...styles }}>
            {this.$slots.default}
          </div>
          <div class="a-dialog-foot">
            {(finish || submit || cancel || reject || action.length > 0) && (
              <div class="a-dialog-foot-action">
                {finish && <el-button size={size} loading={this.loading} on-click={this.finish} type="success">{this.finishText}</el-button>}
                {submit && <el-button size={size} loading={this.loading} on-click={this.submit} type="primary">{this.submitText}</el-button>}
                {reject && <el-button size={size} loading={this.loading} on-click={this.reject} type="danger">{this.rejectText}</el-button>}
                {cancel && <el-button size={size} disabled={this.loading} on-click={this.cancel}>{this.cancelText}</el-button>}
                {action.map((a, b) => (
                  <el-button key={b} size={size} disabled={this.loading} on-click={(e) => a.click(this.format(), e)} {...{ attrs: a }}>
                    {a.label || a.title || a.text || ''}
                  </el-button>
                ))}
              </div>
            )}
          </div>
          {this.$slots.footer}
        </el-dialog>
      </div>
    );
  }
}